import { AddressRO, AddressTypeRO, Address } from 'storage/user/user.model';
import { CountryCode } from 'providers/TranslationProvider/TranslationProvider.model';
import { AddressDTO } from 'storage/client/client.model';

export const initialValuesObject = {
  kind: 'RO' as const,
  addressType: AddressTypeRO.MAIN,
  countryCode: CountryCode.RO,
  street: '',
  buildingNumber: '',
  flatNumber: '',
  city: '',
  county: '',
  entrance: '',
  floor: '',
  streetNumber: ''
};

export function isRomanianAddress(address: Address): address is AddressRO {
  return (
    'entrance' in address &&
    'county' in address &&
    'floor' in address &&
    'streetNumber' in address
  );
}

export const isRomanianAddressDTO = ({
  county,
  streetNumber
}: Pick<AddressDTO, 'county' | 'streetNumber'>): boolean =>
  county !== null && streetNumber !== null;
